export const USER_AGREEMENT_STORAGE_KEY = "lst_user_agreement_accepted_v1";
export function isUserAgreementAccepted() {
    try {
        return localStorage.getItem(USER_AGREEMENT_STORAGE_KEY) === "1";
    }
    catch {
        return false;
    }
}
export function setUserAgreementAccepted() {
    try {
        localStorage.setItem(USER_AGREEMENT_STORAGE_KEY, "1");
    }
    catch {
    }
}
